export const releaseVersion = "v3.12";
console.log("releaseVersion:", "3.12.4");
